import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AppSettings } from '../../app/app.settings';
import { DataProvider } from '../../providers/data';
import { ProductFav } from '../../models/product';

@Component({
  selector: 'page-favourites',
  templateUrl: 'favourites.html',
})
export class FavouritesPage {
  public productGroups: ProductGroup[] = [];
  public curCountry: string;

  public get favProductsCount() {
    return this.dataService.FAV_PRODUCTS_COUNT;
  }

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private dataService: DataProvider) {
    this.curCountry = dataService.CURRENT_COUNTRY;
  }

  ionViewDidEnter() {
    console.log('enteeeer');
    this.refreshProducts();
  }

  ionViewDidLoad() {
    console.log('looooad');
    this.refreshProducts();
  }

  private refreshProducts() {
    this.productGroups = [];
    for (let prodType of AppSettings.PROD_TYPES) {
      let favProdsOfType: ProductFav[] = this.dataService.getFavProducts().filter(p => p.type === prodType);
      if (favProdsOfType.length > 0) {
        this.productGroups.push(new ProductGroup(favProdsOfType.map(p => p.id), prodType));
      }
    }
  }

  public goToTest() {
    this.navCtrl.parent.select(0);
  }
}

class ProductGroup {
  public productIds: number[];
  public type: string;

  constructor(_productIds: number[], _type: string) {
    this.productIds = _productIds;
    this.type = _type;
  }
}



// WEBPACK FOOTER //
// ./src/pages/favourites/favourites.ts